// fhir-id.js — pure predicates over Medplum/FHIR resource ids. No I/O, no DOM,
// no imports: safe for the view-shaper layer (lib/shape/*) and for the future
// portable package to depend on.
//
// It exists because `isMedplumUuid` was defined twice, byte-identical, in two
// I/O-heavy modules (medplum-photo.js, medplum-consult-extras.js) — so anything
// that only needed the 40-character regex test had to import a module that drags
// in the whole Medplum client. Both keep re-exporting it, so every existing
// importer is unchanged.

// Medplum server-assigned resource ids are RFC-4122 UUIDs. Our OWN stable OPD
// identifiers are slugs (see AGENTS.md §3 — the slug/_medplumId split is the
// "patient shown twice" guard), so this predicate is how a call site asks
// "is this the Medplum UUID, or our slug?" before using it as a UUID.
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when `v` is a Medplum resource UUID (not an OPD slug, not empty). */
export function isMedplumUuid(v) { return UUID_RE.test(String(v || '')); }
